// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insured-numbers-selector-panel {
  margin-bottom: 8px !important;
}
.insured-numbers-selector-panel .ant-card-body {
  padding: 0 !important;
}
.insured-numbers-selector-panel .ant-card-body .text-ellipsis-100,
.insured-numbers-selector-panel .ant-card-body .text-ellipsis-150 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/smses/modals/mass-sms/insured-numbers-selector/styles.less"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF;AAFA;EAII,qBAAA;AACJ;AALA;;EAQM,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AACN","sourcesContent":[".insured-numbers-selector-panel {\n  margin-bottom: 8px !important;\n\n  .ant-card-body {\n    padding: 0 !important;\n\n    .text-ellipsis-100,\n    .text-ellipsis-150 {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      display: block;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
